import './App.css';
import './theme.css';
import './cookie.js';
import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeContainer from './components/Home/HomeContainer';
import ProductsContainer from './components/Products/ProductsContainer';
import Cart from './components/Cart/Cart';
import Checkout from './components/Checkout/Checkout';
import ProductCardContainer from './components/Products/Product/ProductCard/ProductCardContainer';
import HeaderContainer from './components/Header/HeaderContainer';
import PolicyContainer from './components/Documents/Policy/PolicyContainer';
import TermsContainer from './components/Documents/Terms/TermsContainer';
import ShippingPolicyContainer from './components/Documents/ShippingPolicy/ShippingPolicyContainer';
import RefundPolicyContainer from './components/Documents/RefundPolicy/RefundPolicyContainer';
import ContactsContainer from './components/Contacts/ContactsContainer';
import AboutContainer from './components/About/AboutContainer';
import NewsContainer from './components/News/NewsContainer';
import CokieContainer from './components/Documents/Cokie/CokieContainer';
import NewsCardContainer from './components/News/NewsInfo/NewsCard/NewsCardContainer';
import SearchContainer from './components/Search/SearchContainer';
import FooterContainer from './components/Footer/FooterContainer';

const App = () => {
  const [cartItems, setCartItems] = useState([]);

  const onAdd = (product) => {
    const exist = cartItems.find((x) => x.productId === product.productId);
    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x.productId === product.productId
            ? { ...exist, qty: exist.qty + 1 }
            : x
        )
      );
    } else {
      setCartItems([...cartItems, { ...product, qty: 1 }]);
    }
  };

  const onRemove = (product) => {
    const exist = cartItems.find((x) => x.productId === product.productId);
    if (exist.qty === 1) {
      setCartItems(cartItems.filter((x) => x.productId !== product.productId));
    } else {
      setCartItems(
        cartItems.map((x) =>
          x.productId === product.productId
            ? { ...exist, qty: exist.qty - 1 }
            : x
        )
      );
    }
  };

  const onBuyItNow = (product) => {
    onAdd(product);
  };
  return (
    <BrowserRouter>
      <div className="app_wrapper">
        <HeaderContainer cartItems={cartItems} />
        <div className="app_content">
          <Routes>
            <Route
              path=""
              element={<HomeContainer onAdd={onAdd} cartItems={cartItems} />}
            />
            <Route path="/news" element={<NewsContainer />} />
            <Route
              path="/about"
              element={<AboutContainer cartItems={cartItems} />}
            />
            <Route
              path="/products"
              element={
                <ProductsContainer onAdd={onAdd} cartItems={cartItems} />
              }
            />
            <Route path="/contacts" element={<ContactsContainer />} />
            <Route
              path="/checkout"
              element={
                <Checkout
                  cartItems={cartItems}
                  onAdd={onAdd}
                  onRemove={onRemove}
                />
              }
            />
            <Route
              path="/cart"
              element={
                <Cart cartItems={cartItems} onAdd={onAdd} onRemove={onRemove} />
              }
            />
            <Route
              path="products/:path"
              element={
                <ProductCardContainer
                  onAdd={onAdd}
                  onBuyItNow={onBuyItNow}
                  cartItems={cartItems}
                />
              }
            />
            <Route
              path="/search"
              element={<SearchContainer onAdd={onAdd} cartItems={cartItems} />}
            />
            <Route path="/policy" element={<PolicyContainer />} />
            <Route path="/terms" element={<TermsContainer />} />
            <Route
              path="/shipping-policy"
              element={<ShippingPolicyContainer />}
            />
            <Route path="/refund-policy" element={<RefundPolicyContainer />} />
            <Route path="/cookies-policy" element={<CokieContainer />} />
          </Routes>
        </div>
        <FooterContainer />
      </div>
    </BrowserRouter>
  );
};

export default App;
